import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import NewNavbar from "components/NewNavbar";
import { STUDENT_ATTENDANCE_STATUS_ARABIC } from "constants/constants";
import { useLanguage } from "context/LanguageContext";
import { useTheme } from "context/ThemeContext";
import { useEffect, useState } from "react";
import { fetchEducationCenters } from "services/data";
import { fetchTraineesAttendance } from "services/watoms/watomsData";

const ViewTraineeAttendance = () => {
    const { language } = useLanguage();
    const { darkMode } = useTheme();
    const [vtcs, setVtcs] = useState([]);
    const [selectedVtc, setSelectedVtc] = useState("");
    const [selectedDay, setSelectedDay] = useState("");
    const [attendance, setAttendance] = useState([]);
    const [filteredAttendance, setFilteredAttendance] = useState([]);

    useEffect(() => {
        const loadVtcs = async () => {
            const response = await fetchEducationCenters(2);
            setVtcs(response);
        }

        const loadTraineesAttendance = async () => {
            const response = await fetchTraineesAttendance();
            setAttendance(response);
        }

        loadVtcs();
        loadTraineesAttendance();
    }, []);

    useEffect(() => {
        let filtered = attendance;

        // Filter by VTC (school)
        if (selectedVtc && selectedVtc !== "All") {
            filtered = filtered.filter(att => att.student?.school_id === Number(selectedVtc));
        }

        // Filter by date
        if (selectedDay) {
            filtered = filtered.filter(att => {
                const attDate = new Date(att.createdAt).toISOString().split("T")[0];
                return attDate === selectedDay;
            });
        }

        setFilteredAttendance(filtered);

    }, [attendance, selectedVtc, selectedDay]);

    return (
        <div className={`w-full min-h-screen ${darkMode && 'bg-watomsBlue text-white'}`}>
            <EbdaEduNavbar />
            <h1 className="text-2xl font-bold text-center">لائحة غياب المتدربين</h1>
            {/* filters */}
            <div className="flex justify-evenly items-center">
                {/* day filter */}
                <div className="flex flex-col justify-center items-center">
                    <label>:اليوم</label>
                    <input
                        className={"w-60 text-black bg-gray-100 rounded p-3"}
                        type="date"
                        value={selectedDay}
                        onChange={(e) => setSelectedDay(e.target.value)}
                    />
                </div>
                {/* organization filter */}
                <div className="flex flex-col justify-center items-center">
                    <label>:المركز</label>
                    <select
                        id="vtc"
                        name="vtc"
                        onChange={(e) => setSelectedVtc(e.target.value)}
                        value={selectedVtc}
                        className="text-black bg-gray-100"
                        dir="rtl"
                    >
                        <option value="" disabled>
                            الرجاء اختيار المركز
                        </option>
                        <option value="All">الكل</option>
                        {vtcs.map((s) => (
                            <option key={s.id} value={s.id}>
                                {s.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            {/* trainee attendance table */}
            <div className="mt-8 px-10">
                <table className="w-full border-collapse border border-gray-300 text-center" dir={language ? "ltr" : "rtl"}>
                    <thead className="text-black bg-gray-100">
                        <tr>
                            <th className="border border-gray-300 p-2">#</th>
                            <th className="border border-gray-300 p-2">{language ? "name" : "اسم المتدرب"}</th>
                            <th className="border border-gray-300 p-2">{language ? "course" : "الدورة التدريبية"}</th>
                            <th className="border border-gray-300 p-2">{language ? "status" : "الحالة"}</th>
                            <th className="border border-gray-300 p-2">{language ? "reason" : "السبب"}</th>
                            <th className="border border-gray-300 p-2">{language ? "vtc" : "المركز"}</th>
                            <th className="border border-gray-300 p-2">{language ? "submit date" : "تاريخ التسجيل"}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredAttendance?.map((item, index) => (
                            <tr key={item.id} className="hover:text-black hover:bg-gray-50">
                                <td className="border border-gray-300 p-2">{language ? index + 1 : (index + 1).toLocaleString('ar-EG')}</td>

                                <td className="border border-gray-300 p-2">
                                    {`${item.student?.first_name} ${item.student?.middle_name} ${item.student?.last_name}`}
                                </td>

                                <td className="border border-gray-300 p-2">
                                    {item.student?.class?.name || "-"}
                                </td>

                                <td className="border border-gray-300 p-2">
                                    {language ? item.status : STUDENT_ATTENDANCE_STATUS_ARABIC[item.status]}
                                </td>

                                <td className="border border-gray-300 p-2">
                                    {item.reason || "-"}
                                </td>

                                <td className="border border-gray-300 p-2">
                                    {item.student?.school?.name || "-"}
                                </td>

                                <td className="border border-gray-300 p-2">
                                    {new Date(item.createdAt).toLocaleDateString("ar-EG")}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ViewTraineeAttendance;